import controller from './controller';
import template from './template.html';

const controllerAs = 'sponsorsCtrl';
const bindings = {
  muted: '<',
  ngModel: '=',
  checkbox: '<',
  columns: '<',
  header: '<'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/sponsors/index.js